
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../components/Context';

//import tags
import { Link } from "react-router-dom";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import BeatLoader from "react-spinners/BeatLoader";


//import resources
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


//import components
import ProfileMenu from './../../components/dynamic/ProfileMenu';

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";

//import api

import { update_user } from './../../api/Api'


function Main({locale}) {
    const { isLoggedIn, updateUserContext, updatedUser } = useAppContext();

    //get locale
    const { t } = useTranslation();
    
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [repassword, setRePassword] = useState('');

    const [loading, setLoadgin] = useState(false);
    const [message, setMessage] = useState(false);

    useEffect(()=> {
        setFname(isLoggedIn?.fname);
        setLname(isLoggedIn?.lname);
        setEmail(isLoggedIn?.email);
        setPhone(isLoggedIn?.phone);

        setLoadgin(false);

    }, [isLoggedIn])


    useEffect(() => {
        if(message) {
            updateUserContext();
        }

    }, [message]);

    const updateUser = async () => {


        if(localStorage.hasOwnProperty('token')) {

            setLoadgin(true);

            const data = {
                'fname': fname,
                'lname': lname,
                'email': email,
                'phone': phone
            }
    
            const header = {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }

            try {
                await update_user(setMessage, data, header);
            } catch (error) {
                console.error('Error fetching data:', error);
            }

        }

        
    }

    return (
        <div className='main'>

            <section className="breadcumbSection" id="sectionBreadCumb">
                <Container>
                    <Row>
                        <Col xxl={12}>
                            <div className="breadcumb">
                                <div className="breadcumbLeft">
                                    <h1>{t('my_profile')}</h1>
                                </div>
                                <div className="breadcumbRight">
                                    <ul>
                                        <li><Link to="/">{t('home')}</Link></li>
                                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                                        <li>{t('my_profile')}</li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="contactSection">
                <Container>
                    <Row>

                        <Col xxl={4}>
                            <ProfileMenu locale={locale} />
                        </Col>

                        <Col xxl={8}>
                            <div className="profileCard">
                                <div className="profileEditBox">
                                    <h4 className="profileEditBoxTitle">{t('personal_info')}</h4>
                                    <Row>
                                        <Col xxl={6}>
                                            <div className="profileForm">
                                                <label>{t('fname')}</label>
                                                <input value={fname ?? ''} onInput={(e)=>setFname(e.target.value)} type="text" name="fname"  placeholder={t('fname')} />
                                            </div>
                                        </Col>
                                        <Col xxl={6}>
                                            <div className="profileForm">
                                                <label>{t('lname')}</label>
                                                <input value={lname ?? ''} onInput={(e)=>setLname(e.target.value)} type="text" name="lname"  placeholder={t('lname')} />
                                            </div>
                                        </Col>
                                        <Col xxl={6}>
                                            <div className="profileForm">
                                                <label>{t('email')}</label>
                                                <input value={email ?? ''} onInput={(e)=>setEmail(e.target.value)} type="text" name="email"  placeholder={t('email')} />
                                            </div>
                                        </Col>
                                        <Col xxl={6}>
                                            <div className="profileForm">
                                                <label>{t('phone')}</label>
                                                <input value={phone ?? ''} onInput={(e)=>setPhone(e.target.value)} type="text" name="phone"  placeholder={t('phone')} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <h4 className="profileEditBoxTitle">{t('change_pass')}</h4>
                                    <Row>
                                        <Col xxl={6}>
                                            <div className="profileForm">
                                                <label>{t('password')}</label>
                                                <input value={password ?? ''} type="text" onInput={(e)=>setPassword(e.target.value)} name="password" placeholder={t('new_pass')} />
                                            </div>
                                        </Col>
                                        <Col xxl={6}>
                                            <div className="profileForm">
                                                <label>{t('repeat_password')}</label>
                                                <input value={repassword ?? ''} type="text" onInput={(e)=>setRePassword(e.target.value)} name="repass" placeholder={t('repeat_password')} />
                                            </div>
                                        </Col>
                                        <Col xxl={12}>
                                            <div className="saveProfile">

                                                { loading ? 
                                                    <Button className='saveButton'>
                                                        <BeatLoader
                                                            color='#fff'
                                                            size={10}
                                                            aria-label="Loading Spinner"
                                                            data-testid="loader"
                                                        />
                                                    </Button>
                                                : 
                                                    <Button className='saveButton' onClick={updateUser}>
                                                        {t('update_profile')}
                                                    </Button>
                                                }

                                                
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>

                    </Row>
                </Container>
            </section>
        </div>
        
    )

}

export default Main;